import { track } from 'shared/models/analytic';

const APP_CONTAINER_ID = 'app-container';

const LOAD_VARIANT = 'LOAD_VARIANT';
const CACHE_SCROLL_POSITION = 'CACHE_SCROLL_POSITION';
const UNCACHE_SCROLL_POSITION = 'UNCACHE_SCROLL_POSITION';

const init = {
  experiments: {},
  scrollY: null
};

export default function(state = init, action = {}) {
  switch (action.type) {
    case LOAD_VARIANT:
      return {
        ...state,
        experiments: { ...state.experiments, ...action.experiments }
      };
    case CACHE_SCROLL_POSITION:
      return { ...state, scrollY: action.scrollY };
    case UNCACHE_SCROLL_POSITION:
      return { ...state, scrollY: null };
    default:
      return state;
  }
}

export function loadVariant(experimentName, variantName) {
  return dispatch => {
    dispatch({
      type: LOAD_VARIANT,
      experiments: { [experimentName]: variantName }
    });
    track('Experiment Group', { experimentName, variantName });
  };
}

export function preserveAppScroll() {
  return (dispatch, getState) => {
    if (typeof window === 'undefined') return;
    const cartOpen = getState().cart.show;
    if (cartOpen) {
      const appContainer = document.getElementById(APP_CONTAINER_ID);
      const scrollY = appContainer.scrollTop;
      dispatch({ type: CACHE_SCROLL_POSITION, scrollY });
    } else {
      const scrollY = window.scrollY;
      dispatch({ type: CACHE_SCROLL_POSITION, scrollY });
    }
  };
}

export function applyAppScroll() {
  return (dispatch, getState) => {
    if (typeof window === 'undefined') return;
    const cartOpen = getState().cart.show;
    const scrollY = getState().app.scrollY;
    if (cartOpen) {
      const appContainer = document.getElementById(APP_CONTAINER_ID);
      appContainer.scrollTop = scrollY;
      dispatch({ type: UNCACHE_SCROLL_POSITION });
    } else {
      window.scrollTo(0, scrollY);
      dispatch({ type: UNCACHE_SCROLL_POSITION });
    }
  };
}

export { APP_CONTAINER_ID };
